const initHowToBlock = async () => {
  const blocks = document.querySelectorAll('.block-acf---how-to')
  if (!blocks.length) return

  // Lazy-load Swiper + its CSS only when at least one how-to block is present.
  // Saves ~28 KiB on every page without a how-to block.
  const [{ default: Swiper }, { Navigation, Pagination }] = await Promise.all([
    import(/* webpackChunkName: "swiper" */ 'swiper'),
    import(/* webpackChunkName: "swiper" */ 'swiper/modules'),
    import(/* webpackChunkName: "swiper" */ 'swiper/css'),
    import(/* webpackChunkName: "swiper" */ 'swiper/css/navigation'),
    import(/* webpackChunkName: "swiper" */ 'swiper/css/pagination')
  ])

  blocks.forEach((block) => {
    const swiperElement = block.querySelector('.swiper')
    if (!swiperElement) return

    new Swiper(swiperElement, {
      modules: [Navigation, Pagination],
      grabCursor: true,
      watchSlidesProgress: true,
      loop: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 0,
      initialSlide: 0,
      on: {
        progress(swiper) {
          const totalSlides = swiper.slides.length

          for (let i = 0; i < totalSlides; i++) {
            const slide = swiper.slides[i]
            const progress = slide.progress
            const absProgress = Math.abs(progress)
            const offsetX = 82.5

            // Scale factor for slides further away from center
            let scaleMultiplier = 1
            if (absProgress > 1) {
              scaleMultiplier = 0.3 * (absProgress - 1) + 1
            }

            // Calculate translation and scale
            const translateX = progress * scaleMultiplier * offsetX + '%'
            const scale = 1 - 0.25 * absProgress

            // zIndex: higher for slides closer to center
            const zIndex = totalSlides - Math.abs(Math.round(progress))

            // Apply styles to the slide
            slide.style.transform = `translateX(${translateX}) scale(${scale})`
            slide.style.zIndex = zIndex.toString()
            slide.style.opacity = (absProgress > 3 ? 0 : 1).toString()

            // Find all elements inside the slide with this class
            const innerSlides = slide.querySelectorAll('.slide__content-wrapper, .slide__cta-wrapper')
            if (innerSlides.length) {
              // Fade out inner content based on distance from center
              innerSlides.forEach((inner) => {
                inner.style.opacity = (1 - absProgress / 3).toString()
              })
            }
          }
        },

        setTransition(swiper, duration) {
          for (let i = 0; i < swiper.slides.length; i++) {
            const slide = swiper.slides[i]

            // Set transition duration for the slide
            slide.style.transitionDuration = `${duration}ms`

            // Set transition duration for inner elements
            const innerSlides = slide.querySelectorAll('.slide__content-wrapper, .slide__cta-wrapper')
            if (innerSlides.length) {
              innerSlides.forEach((inner) => {
                inner.style.transitionDuration = `${duration}ms`
              })
            }
          }
        }
      },
      breakpoints: {
        576: {
          pagination: false
        }
      },
      pagination: {
        el: block.querySelector('.swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: block.querySelector('.swiper-button-next'),
        prevEl: block.querySelector('.swiper-button-prev')
      }
    })
  })
}

initHowToBlock()
